import { memo, useMemo } from "react";

import { formatNumber } from "utils";
import { calculateMarketCap } from "./type";
import { StockResult } from "@/src/hooks/useStockDashboard";
import { useStockField } from "@/src/hooks";

interface StockMarketCapProps {
  /** 股票数据 */
  stock: StockResult;
}

const StockMarketCapOrg = ({ stock }: StockMarketCapProps) => {
  const stockData = useStockField(
    stock?.symbol,
    "p",
    stock?.trading_data?.current_price,
  );

  // 使用 useMemo 缓存计算结果
  const displayText = useMemo(() => {
    if (!stockData?.value || !stock?.trading_data?.shares_outstanding) {
      return "--";
    }
    const currentPrice = Number(stockData?.value || 0);
    const sharesOutstanding = Number(
      stock?.trading_data?.shares_outstanding || 0,
    );
    const marketCap = calculateMarketCap(currentPrice, sharesOutstanding);
    return `$${formatNumber(marketCap)}`;
  }, [stockData?.value, stock?.trading_data?.shares_outstanding]);

  return (
    <span className="body_medium_m text-content_primary">{displayText}</span>
  );
};

export const StockMarketCap = memo(StockMarketCapOrg);
